import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'search-with-select',
  templateUrl: './search-with-select.component.html',
  styleUrls: ['./search-with-select.component.scss']
})
export class SearchWithSelectComponent {

  showBlocked: boolean = localStorage.getItem('showBlocked') === 'true'

  text: string = ""

  @Input()
  showCheckbox: boolean

  @Input()
  loadingVideos: boolean

  hasYoutubeNakiProfile: boolean
  confirmedAddingProfile: boolean



  @Output() showBlockedChanged = new EventEmitter();

  constructor(private router: Router, private route: ActivatedRoute, private usersService: UsersService) { }


  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.text = params['text']
      },
        err => console.log(err))
    this.hasSharatYoutubeNakiProfile()
    this.checkIfConfirmedAddingProfile()
  }

  searchVideos() {
    if (this.text !== undefined && this.text !== "") {
      const showBlocked = localStorage.getItem('showBlocked') === 'true'
      this.router.navigate([`search`], { queryParams: { 'text': this.text, 'showBlocked': showBlocked } })
    }
  }

  searchVideosAndTags(text: string) {
    this.text = text
    const showBlocked = localStorage.getItem('showBlocked') === 'true'
    this.router.navigate([`search`], { queryParams: { 'text': text, 'showBlocked': showBlocked } })
  }

  showBlockesSave() {
    localStorage.setItem('showBlocked', String(this.showBlocked))
    this.showBlockedChanged.emit()
    this.searchVideos()
  }

  hasSharatYoutubeNakiProfile() {
    this.hasYoutubeNakiProfile = JSON.parse(localStorage.getItem('user')).profiles.includes(-223)
  }

  checkIfConfirmedAddingProfile() {
    this.confirmedAddingProfile = JSON.parse(localStorage.getItem('confirmedAddingProfile'))
  }


}
